"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";

const _interactionsData = JSON.parse(
  '{"events":{"e-45":{"id":"e-45","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-17","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-46"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".gallery_overlay-trigger","originalId":"f2687902-42de-0ebd-427b-fa1ba1e6693f","appliesTo":"CLASS"},"targets":[{"selector":".gallery_overlay-trigger","originalId":"f2687902-42de-0ebd-427b-fa1ba1e6693f","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1702675855485},"e-46":{"id":"e-46","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-18","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-45"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".gallery_overlay-trigger","originalId":"f2687902-42de-0ebd-427b-fa1ba1e6693f","appliesTo":"CLASS"},"targets":[{"selector":".gallery_overlay-trigger","originalId":"f2687902-42de-0ebd-427b-fa1ba1e6693f","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1702675855485}},"actionLists":{"a-17":{"id":"a-17","title":"Gallery Overlay [show]","actionItemGroups":[{"actionItems":[{"id":"a-17-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".gallery_overlay","selectorGuids":["040e546d-12f8-255d-b6ec-896d5158c108"]},"value":"none"}},{"id":"a-17-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".gallery_overlay","selectorGuids":["040e546d-12f8-255d-b6ec-896d5158c108"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-17-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".gallery_overlay","selectorGuids":["040e546d-12f8-255d-b6ec-896d5158c108"]},"value":"flex"}},{"id":"a-17-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".gallery_overlay","selectorGuids":["040e546d-12f8-255d-b6ec-896d5158c108"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1702675650763},"a-18":{"id":"a-18","title":"Gallery Overlay [hide]","actionItemGroups":[{"actionItems":[{"id":"a-18-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".gallery_overlay","selectorGuids":["040e546d-12f8-255d-b6ec-896d5158c108"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-18-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"ease","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".gallery_overlay","selectorGuids":["040e546d-12f8-255d-b6ec-896d5158c108"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1702675650763}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function Gallery({
  as: _Component = _Builtin.Block,
  cPropertyName = "Property C",
  cCitySt = "City St",
  cPhoto = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657b7c71362661ac79cd6a89_656bfaeceb67cdaa0cf9a98f_Rectangle-75.png",
  ePropertyName = "Property Name",
  eCityState = "City St",
  ePhoto = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657b7c70362661ac79cd6a2f_656bfaeddb45837be3acc198_Rectangle-79.png",
  fPropertyF = "Property Name",
  fCitySt = "City State",
  fPhoto = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657b7c7072f09e07739d6052_656bfaefeb3430d878b90f9c_Rectangle-100.png",
  gPropertyName = "Property G",
  gCitySt = "City St",
  gPhoto = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657b7c718d723864f21984d1_656bfaf3db45837be3acc7e3_Rectangle-80.png",
  hPropertyName = "Property H",
  hCitySt = "City St",
  hPhoto = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657b7c70b226919e9020a78f_656bfaee4d62d200a44fab6a_Rectangle-82.png",
  _1X1APropertyName = "Prop ABC",
  _1X1ACityState = "City ST",
  _1X1APhoto = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657b7c709a5154e5ab314932_656bfaf0cdeed95e4ef3c9e1_Rectangle-76.png",
  _2X1DPropertyName = "Property D",
  _2X1DCitySt = "Scottsdale AZ",
  _2X1DPhoto = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657b7c7041f16c7520f19c4d_656bfaf0cdeed95e4ef3ca26_Rectangle-81.png",
  _1X2BPropertyName = "Property Name",
  _1X2BCityState = "City State",
  _1X2BPhoto = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657b7c706765264ba66aa587_656bfaf2267148cebcfc288d_Rectangle-74.png",
}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <_Component className="gallery" tag="section">
      <_Builtin.Block className="gallery_grid" tag="div">
        <_Builtin.Block className="image-3x2" tag="div">
          <_Builtin.Image
            className="gallery_image"
            id="w-node-f2687902-42de-0ebd-427b-fa1ba1e6693e-a1e6693b"
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dcb939b4c30a8cdc0c5fd9_1-Cyrene%20at%20Fiddyment.jpeg"
          />
          <_Builtin.Link
            className="gallery_overlay-trigger"
            button={false}
            aria-label="This is not a link at this time."
            block="inline"
            options={{
              href: "#",
            }}
          >
            <_Builtin.Block className="gallery_overlay" tag="div">
              <_Builtin.Block tag="div">
                <_Builtin.Block
                  className="margin-bottom margin-xsmall"
                  tag="div"
                >
                  <_Builtin.Block className="text-size-large" tag="div">
                    {"Cyrene at Fiddyment"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block tag="div">{"Roseville, CA"}</_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Link>
        </_Builtin.Block>
        <_Builtin.Block
          className="image-1x2"
          id="w-node-f2687902-42de-0ebd-427b-fa1ba1e66947-a1e6693b"
          tag="div"
        >
          <_Builtin.Image
            className="gallery_image"
            id="w-node-f2687902-42de-0ebd-427b-fa1ba1e66948-a1e6693b"
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/6762f7f2f03983a540d5e9c2_domain%20adrian.jpg"
          />
          <_Builtin.Link
            className="gallery_overlay-trigger"
            button={false}
            aria-label="This is not a link at this time"
            block="inline"
            options={{
              href: "#",
            }}
          >
            <_Builtin.Block className="gallery_overlay" tag="div">
              <_Builtin.Block tag="div">
                <_Builtin.Block
                  className="margin-bottom margin-xsmall"
                  tag="div"
                >
                  <_Builtin.Block className="text-size-large" tag="div">
                    {"Domain WeHo"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block tag="div">
                  {"West Hollywood, CA"}
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Link>
        </_Builtin.Block>
        <_Builtin.Block
          className="image-3x2"
          id="w-node-f2687902-42de-0ebd-427b-fa1ba1e66951-a1e6693b"
          tag="div"
        >
          <_Builtin.Image
            className="gallery_image"
            id="w-node-f2687902-42de-0ebd-427b-fa1ba1e66952-a1e6693b"
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dcb93993210214a7a068c2_2-Level%20at%20Sixteenth.jpeg"
          />
          <_Builtin.Link
            className="gallery_overlay-trigger"
            button={false}
            aria-label="Thi is not a link at this time"
            block="inline"
            options={{
              href: "#",
            }}
          >
            <_Builtin.Block className="gallery_overlay" tag="div">
              <_Builtin.Block tag="div">
                <_Builtin.Block
                  className="margin-bottom margin-xsmall"
                  tag="div"
                >
                  <_Builtin.Block className="text-size-large" tag="div">
                    {"Level at Sixteenth"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block tag="div">{"Scottsdale AZ"}</_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Link>
        </_Builtin.Block>
        <_Builtin.Block
          className="image-2x1"
          id="w-node-f2687902-42de-0ebd-427b-fa1ba1e6695b-a1e6693b"
          tag="div"
        >
          <_Builtin.Image
            className="gallery_image"
            id="w-node-f2687902-42de-0ebd-427b-fa1ba1e6695c-a1e6693b"
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dcb939441387dfa8413294_5-Palomino.jpeg"
          />
          <_Builtin.Link
            className="gallery_overlay-trigger"
            button={false}
            aria-label="This is no a link at this time."
            block="inline"
            options={{
              href: "#",
            }}
          >
            <_Builtin.Block className="gallery_overlay" tag="div">
              <_Builtin.Block tag="div">
                <_Builtin.Block
                  className="margin-bottom margin-xsmall"
                  tag="div"
                >
                  <_Builtin.Block className="text-size-large" tag="div">
                    {"Palomino"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block tag="div">{"Reno, NV"}</_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Link>
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block className="gallery_grid" tag="div">
        <_Builtin.Block
          className="image-2x1"
          id="w-node-f2687902-42de-0ebd-427b-fa1ba1e66966-a1e6693b"
          tag="div"
        >
          <_Builtin.Image
            className="gallery_image"
            id="w-node-f2687902-42de-0ebd-427b-fa1ba1e66967-a1e6693b"
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dcb939f00b356f854d27e4_7-royce.jpeg"
          />
          <_Builtin.Link
            className="gallery_overlay-trigger"
            button={false}
            aria-label="This is not a link at this time"
            block="inline"
            options={{
              href: "#",
            }}
          >
            <_Builtin.Block className="gallery_overlay" tag="div">
              <_Builtin.Block tag="div">
                <_Builtin.Block
                  className="margin-bottom margin-xsmall"
                  tag="div"
                >
                  <_Builtin.Block className="text-size-large" tag="div">
                    {"Promenade Rio Vista"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block tag="div">{"San Diego, CA"}</_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Link>
        </_Builtin.Block>
        <_Builtin.Block
          className="image-1x2"
          id="w-node-f2687902-42de-0ebd-427b-fa1ba1e66970-a1e6693b"
          tag="div"
        >
          <_Builtin.Image
            className="gallery_image"
            id="w-node-f2687902-42de-0ebd-427b-fa1ba1e66971-a1e6693b"
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dcb939ffcaf05e124725df_6-1250%20Lakeside.jpeg"
          />
          <_Builtin.Link
            className="gallery_overlay-trigger"
            button={false}
            aria-label="This is not a link at this time."
            block="inline"
            options={{
              href: "#",
            }}
          >
            <_Builtin.Block className="gallery_overlay" tag="div">
              <_Builtin.Block tag="div">
                <_Builtin.Block
                  className="margin-bottom margin-xsmall"
                  tag="div"
                >
                  <_Builtin.Block className="text-size-large" tag="div">
                    {"1250 Lakeside"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block tag="div">{"Sunnyvale, CA"}</_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Link>
        </_Builtin.Block>
        <_Builtin.Block
          className="image-3x2"
          id="w-node-f2687902-42de-0ebd-427b-fa1ba1e6697a-a1e6693b"
          tag="div"
        >
          <_Builtin.Image
            className="gallery_image"
            id="w-node-f2687902-42de-0ebd-427b-fa1ba1e6697b-a1e6693b"
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/6762f690a41f9bb5fb6b77f4_CapitolYards_11182015_072.jpg"
          />
          <_Builtin.Link
            className="gallery_overlay-trigger"
            button={false}
            aria-label="This is not a link at this time"
            block="inline"
            options={{
              href: "#",
            }}
          >
            <_Builtin.Block className="gallery_overlay" tag="div">
              <_Builtin.Block tag="div">
                <_Builtin.Block
                  className="margin-bottom margin-xsmall"
                  tag="div"
                >
                  <_Builtin.Block className="text-size-large" tag="div">
                    {"Capitol Yards"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block tag="div">
                  {"West Sacramento, CA"}
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Link>
        </_Builtin.Block>
        <_Builtin.Block
          className="image-3x2"
          id="w-node-f2687902-42de-0ebd-427b-fa1ba1e66984-a1e6693b"
          tag="div"
        >
          <_Builtin.Image
            className="gallery_image"
            id="w-node-f2687902-42de-0ebd-427b-fa1ba1e66985-a1e6693b"
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dcb939e62518487bdcf30c_8-The%20Heights%20at%20Park%20Lane.jpeg"
          />
          <_Builtin.Link
            className="gallery_overlay-trigger"
            button={false}
            aria-label="This is not a link at this time"
            block="inline"
            options={{
              href: "#",
            }}
          >
            <_Builtin.Block className="gallery_overlay" tag="div">
              <_Builtin.Block tag="div">
                <_Builtin.Block
                  className="margin-bottom margin-xsmall"
                  tag="div"
                >
                  <_Builtin.Block className="text-size-large" tag="div">
                    {"The Heights at Park Lane"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block tag="div">{"Dallas, TX"}</_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Link>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
